import { render, staticRenderFns } from "./PainelAcesso.vue?vue&type=template&id=4230bb61&scoped=true"
import script from "./PainelAcesso.vue?vue&type=script&lang=js"
export * from "./PainelAcesso.vue?vue&type=script&lang=js"
import style0 from "./PainelAcesso.vue?vue&type=style&index=0&id=4230bb61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4230bb61",
  null
  
)

export default component.exports